// BULK DOWNLOAD OF THE TICKED DRAWINGS (owner, 2026-10-21: "a bulk download
// button to checked shop drawings that asks 2 options"). Its own component,
// state and dialog, because the page sits at the hooks lint's path limit.
//
// Separate files: a zip with the register PDF and one file per drawing, named
// as its row. One PDF: the register on top, then every drawing. Whatever could
// not be included (nothing delivered, an unreadable file, a DWG in one PDF) is
// said in the message, in the zip's NOT INCLUDED.txt and on the PDF's last page.
import React, { useState } from "react";
import { Button, Modal, Radio, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { downloadShopDrawingBundle } from "api/tracking/shopDrawingsApi";

export function bundleMessage(r, mode) {
  const what = mode === "combined" ? "One PDF" : "Zip";
  // "downloading": the browser takes over the file from here (its download bar).
  const base = `${what} downloading - ${r.included} of ${r.count} drawing${r.count === 1 ? "" : "s"} with the register`;
  if (!r.missing) return { level: "success", text: base };
  return {
    level: "warning",
    text: `${base}. ${r.missing} not included${r.missingNames ? `: ${r.missingNames.split(" | ").join(", ")}` : ""} - the reasons are ${mode === "combined" ? "on the last page" : "in NOT INCLUDED.txt"}.`,
  };
}

export default function BulkDownloadButton({ projectId, ids }) {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("separate");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await downloadShopDrawingBundle(projectId, ids, mode);
      const m = bundleMessage(r, mode);
      message[m.level](m.text, m.level === "warning" ? 8 : 4);
      setOpen(false);
    } catch (e) {
      message.error(e.message || "Could not build the download");
    } finally {
      setBusy(false);
    }
  };
  if (!ids.length) return null;
  return (
    <>
      <Button size="small" icon={<DownloadOutlined />} onClick={() => setOpen(true)} data-testid="sd-bulk-download">
        Download {ids.length.toLocaleString()}
      </Button>
      <Modal
        open={open}
        title={`Download ${ids.length.toLocaleString()} shop drawing${ids.length === 1 ? "" : "s"}`}
        okText="Download"
        okButtonProps={{ loading: busy, "data-testid": "sd-bulk-download-go" }}
        onOk={go}
        onCancel={() => { if (!busy) setOpen(false); }}
        destroyOnClose
      >
        <Radio.Group value={mode} onChange={(e) => setMode(e.target.value)} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Radio value="separate" data-testid="sd-bulk-mode-separate">
            <b>Separate PDFs</b> (zip)
            <div style={{ color: "#667085", fontSize: 12, marginLeft: 24 }}>
              Each drawing as its own file, named as its row, with the register as a PDF in the same folder.
            </div>
          </Radio>
          <Radio value="combined" data-testid="sd-bulk-mode-combined">
            <b>One combined PDF</b>
            <div style={{ color: "#667085", fontSize: 12, marginLeft: 24 }}>
              The register on top, then every drawing in the order on screen. Files that are not PDFs or images (a DWG) are listed on the last page instead.
            </div>
          </Radio>
        </Radio.Group>
      </Modal>
    </>
  );
}
